import {BaseService} from "./base.service";

class StationeryService extends BaseService {

    constructor() {
        super('api/stationery')
    }

}

export const stationeryService = new StationeryService();
